import { useLocale } from 'state/intl';

import { useLoyaltyActiveCard } from './loyalty';

enum BarCodeToCountry {
  '0464' = 'US',
  '0474' = 'US',
  '0463' = 'CA',
  '0473' = 'CA',
}

export default () => {
  const { region } = useLocale();
  const { activeCard, loading } = useLoyaltyActiveCard();

  return {
    loading,
    isInSameRegion:
      activeCard &&
      activeCard.barcode &&
      BarCodeToCountry[activeCard.barcode.substr(0, 4)] === region,
    loyaltyRegion:
      activeCard && activeCard.barcode && BarCodeToCountry[activeCard.barcode.substr(0, 4)],
  };
};
